export const jobGroupPermissions = {
    List: 11000,
    Create: 11001,
    Update: 11002,
    ShowDetails: 11003,
    Delete: 11004,
    LockUnLock: 11005,
}
export const jobPermissions = {
    List: 12000,
    Create: 12001,
    Update: 12002,
    ShowDetails: 12003,
    Delete: 12004,
    LockUnLock: 12005,
}
export const universityPermissions = {
    List: 13000,
    Create: 13001,
    Update: 13002,
    ShowDetails: 13003,
    Delete: 13004,
    LockUnLock: 13005,
}
export const specialtyPermissions = {
    List: 14000,
    Create: 14001,
    Update: 14002,
    ShowDetails: 14003,
    Delete: 14004,
    LockUnLock: 14005,
}
export const bankPermissions = {
    List: 15000,
    Create: 15001,
    Update: 15002,
    ShowDetails: 15003,
    Delete: 15004,
    LockUnLock: 15005,
}

export const localityPermissions = {
    List: 28000,
    Create: 28001,
    Update: 28002,
    ShowDetails: 28003,
    Delete: 28004,
    LockUnLock: 28005,
}
